import getClientsDetailLink from 'src/common/utils/getClientsDetailLink';

const useClientNameRenderer = ({
  clientData,
  invoice = null,
  isCBOProvider = false,
  hasAccess = true,
  onDrawerOpen,
  hbh1509ClientsDrawerP2Enabled = null,
  additionalProps = {},
}) => {
  const renderClientName = () => {
    let type = 'text';

    // Different logic based on component context
    if (isCBOProvider) {
      // For invoice components
      if (hbh1509ClientsDrawerP2Enabled && clientData) {
        type = 'button';
      } else {
        type = 'link';
      }
    } else if (hasAccess !== undefined) {
      // For components with access control (like ClientDetailsCard)
      if (hasAccess && clientData) {
        type = hbh1509ClientsDrawerP2Enabled ? 'button' : 'link';
      } else {
        type = 'text';
      }
    } else if (hbh1509ClientsDrawerP2Enabled) {
      // For other components (like ViewEligibilityAssessment)
      type = 'button';
    }

    return getClientsDetailLink({
      person: clientData,
      onClick: onDrawerOpen,
      type,
      fallbackName: invoice?.client_name,
      fallbackId: invoice?.client_id,
      ...additionalProps,
    });
  };

  return { renderClientName };
};

export default useClientNameRenderer;
